import { h } from 'preact';
import PropTypes from 'prop-types';

import AutoPushNotifications from '../../containers/auto-push-notifications/auto-push-notifications';
import { renderInDialog } from '../../containers/auto-push-notifications/renderers/render-in-dialog';
import {
  autoPushNotificationsActions,
  autoPushNotificationsStore,
} from '../../../global-store/subjects/auto-push-notifications';
import { useSubscribe } from '../../hooks/use-subscribe';
import { initInDialog } from '../../containers/auto-push-notifications/helpers/init-in-dialog';
import { renderInPage } from '../../containers/auto-push-notifications/renderers/render-in-page';
import { initInPage } from '../../containers/auto-push-notifications/helpers/init-in-page';

const IN_PAGE_POSITION = 'in-page';

export const AutoPushNotificationsComponent = ({ $root, htmlProps, widget }) => {
  const state = useSubscribe(autoPushNotificationsStore);
  return (
    <AutoPushNotifications
      htmlProps={htmlProps}
      widget={widget}
      $root={$root}
      state={state}
      actions={autoPushNotificationsActions}
      render={htmlProps.position === IN_PAGE_POSITION ? renderInPage : renderInDialog}
      initCallback={htmlProps.position === IN_PAGE_POSITION ? initInPage : initInDialog}
    />
  );
};

AutoPushNotificationsComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
